import Vue from 'vue';
import store from 'store/mainStore';
import 'es6-promise/auto';
import 'quasar/dist/quasar.umd.min';

(function(wv, undefined){
	wv.store = store;
	wv.groupAll = new Vue({
		el: "#groupAllContainerWrapper",
		store,
		components: {
			'group-all-main': () => import(/* webpackPrefetch: true */ 'components/groupAll/groupAllMain'),
		},
	});
}( window.wv = window.wv || {} ));